module.exports = "/_assets/images/theming/hex-characters/corval-hex-board-discussion.png";